module.exports = __webpack_public_path__ + "img/usericon.35ce05ea.jpg";